import { render } from "./BackgroundNumberStyle.vue?vue&type=template&id=35092d34&scoped=true"
import script from "./BackgroundNumberStyle.vue?vue&type=script&lang=js"
export * from "./BackgroundNumberStyle.vue?vue&type=script&lang=js"

import "./BackgroundNumberStyle.vue?vue&type=style&index=0&id=35092d34&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35092d34"]])

export default __exports__